<!--  -->
<template>
  <div class="">
    <el-select
      v-model="TypeId"
      placeholder="请选择"
      style="margin-right: 10px"
      @change="onChangeType"
    >
      <el-option
        v-for="item in classList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button type="primary" @click="onClickCreate"
      >生成自定义表格2模板</el-button
    >
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55"> </el-table-column>

        <!-- <el-table-column type="index" width="55"> </el-table-column> -->
        <el-table-column prop="Id" label="Id" width="150" align="center">
        </el-table-column>
        <el-table-column prop="Name" label="表格名" align="center">
        </el-table-column>
        <el-table-column prop="Title" label="名称" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="onClicKEdit(scope.row)"
              >编辑表格名称</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 表格2名称编辑 -->
    <el-dialog
      title="表格2名称"
      :visible.sync="dialogVisibleTable"
      width="30%"
      center
    >
      <div>
        <el-input
          type="text"
          placeholder="请输入表格2名称"
          v-model="tableInput"
          maxlength="20"
          show-word-limit
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTable = false">取 消</el-button>
        <el-button type="primary" @click="SaveTableTwoTitle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetTableTwoTitle,
  SaveTableTwoTitle,
  GetEditQuestion,
  AutoProceCustomInfo,
} from "../../api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
      tableInput: "",
      dialogVisibleTable: false,
      tableData: [], //教师列表
      selsectId: [], //多选选中的Id
      Name: "",
      TypeId: 2,
      classList: [
        {
          label: "托班",
          value: 4,
        },
        {
          label: "小中大",
          value: 2,
        },
      ],
    };
  },
  //方法集合
  methods: {
    // 生成自定义表格2模板
    async onClickCreate() {
      let res = await AutoProceCustomInfo({
        id: 0,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.GetEditQuestion();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    onChangeType(e) {
      this.TypeId = e;
      this.GetEditQuestion();
    },
    // 问题列表
    GetEditQuestion() {
      GetEditQuestion({
        TypeId: this.TypeId,
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response;
        } else {
          this.tableData = [];
        }
      });
    },
    // 表格2名称编辑
    async onClicKEdit(item) {
      //console.log(item);
      this.Name = item.Name + "表头";
      let res = await GetTableTwoTitle({ Name: this.Name });
      if (res.data.success) {
        this.dialogVisibleTable = true;
        this.tableInput = res.data.response;
      }
    },
    // 保存表格2
    async SaveTableTwoTitle() {
      if (this.tableInput != "") {
        let res = await SaveTableTwoTitle({
          title: this.tableInput,
          Name: this.Name,
        });
        if (res.data.success) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.GetEditQuestion();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.dialogVisibleTable = false;
      }
    },

    //多选功能
    handleSelectionChange(val) {
      let list = [];
      val.forEach((item) => {
        if (!list.includes(item.Id)) {
          list.push(item.Id);
        }
      });
      this.selsectId = list;
    },

    //编辑按钮
    handleEdit(index, row) {
      this.$router.push({
        path: "/ProceQuestionEdit?Name=" + row.Name + "&TypeId=" + this.TypeId,
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  mounted() {
    this.GetEditQuestion();
  },
};
</script>
<style scoped>
.role {
  width: 120px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 5px;
}
.roles {
  background: #409eff;
  color: #ffffff;
  border-color: #409eff;
}
.btns {
  margin-top: 20px;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
.mask {
  width: 500px;
  height: 420px;
  position: absolute;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 24%;
  top: 20%;
}
.mask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
.form {
  padding: 10px 30px;
}
.editmask {
  position: absolute;
  z-index: 100;
  /* margin: 0 auto; */
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 30%;
  top: 0%;
}
.editmask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
</style>